/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/exclamation'
export default icon
